// extracted by mini-css-extract-plugin
export var layout = "layout-module--layout--TLxZb";
export var main = "layout-module--main--h1MFv";